<template>
  <div class="events page-component">
    <div class="container">
      <h1 class="text-center">{{ title }}</h1>
      <div class="events__container" v-if="events && events.length > 0">
        <div v-for="event in events.slice(0, eventCountlimit)"
             :key="event.id"
             @click="showModal(event)"
             class="events__item"
        >
          <div class="events__item-date">
            <span class="events__item-date-day">{{ getDay(event.datestart) }}</span>
            <span class="events__item-date-month">{{ getMonthString(KriensTourismus.language, event.datestart) }}</span>
          </div>
          <div class="events__item-content">
            <span class="text-secondary">{{ event.location}}, {{ event.town }}</span>
            <h3>{{ event.title }}</h3>
          </div>
        </div>
      </div>
      <div class="container text-center" v-if="events && events.length > 0">
        <a v-if="eventCountlimit < 100"
           class="btn btn-read-more"
           @click="eventCountlimit = 100">
            {{ KriensTourismus.languageKeys['show-more'] }}
        </a>
      </div>
      <modal height="auto"
           :scrollable="true"
           name="event-detail-modal"
           :adaptive="true"
      >
        <div class="modal-content" v-if="selectedEvent">
          <h2>{{ selectedEvent.title }}</h2>

          <h4>{{ selectedEvent.addinfo }}</h4>
          <p v-html="selectedEvent.eventlang_content"></p>
          <p>{{ selectedEvent.eventlang_description }}</p>
          <h4>{{ KriensTourismus.languageKeys['event-location'] }}</h4>
          <p>
            {{ selectedEvent.location }} <br v-if="selectedEvent.town"/>
            {{ selectedEvent.street }} <br v-if="selectedEvent.street" />
            {{ selectedEvent.zip}} {{ selectedEvent.town }}
          </p>
          <h4>{{ KriensTourismus.languageKeys['organisator'] }}</h4>
          <p>
            <span v-for="organisator in selectedEvent.organisatorArray" :key="organisator.id">
              {{ organisator.displayfield }}<br/>
            </span>
            <span>{{ selectedEvent.phone }}</span><br v-if="selectedEvent.phone" />
            <a v-if="selectedEvent.email" :href="'mailto:' + selectedEvent.email">{{ selectedEvent.email }}</a>
          </p>
          <br />
          <a v-if="selectedEvent.link" 
            class="btn btn-primary btn--large"
            :href="selectedEvent.link"
            target="_blank"
          >
            {{ KriensTourismus.languageKeys['to-website'] }}
          </a>
        </div>
      </modal>
      <div class="container-sm text-center" v-if="!events">
        <svg version="1.1" id="loading-spinner" xmlns="http: //www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"></path>
        </svg>
      </div>
      <div class="container-sm text-center" v-if="events && events.length <= 0">
        <div class="alert alert--error">
          <strong>Error</strong><br>
          {{ KriensTourismus.languageKeys['error-while-calling-api'] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import DateUtils from '../utils/DateUtils'

export default {
  name: 'Events',
  props: ['title', 'lead'],
  data () {
    return {
      events: null,
      selectedEvent: null,
      eventCountlimit: 6,
      apiKey: '5824DB483C9D084EDBD34CF67457E558',
      categories: {
        PARKBAD_KRIENS: 6,
        KULTURQUADRAT: 22,
        AGENDA: 21,
        BRAUCHTUM: 9,
        KULTUR: 10,
        FESTE_PARTIES: 12,
        FREIZEIT: 15,
        UMWELT_NATUR: 19
      }
    }
  },
  created () {
    this.getEvents()
  },
  methods: {
    getEvents () {
      let categoryString = this.categories.PARKBAD_KRIENS + ',' +
                           this.categories.KULTURQUADRAT + ',' +
                           this.categories.AGENDA + ',' +
                           this.categories.BRAUCHTUM + ',' +
                           this.categories.KULTUR + ',' +
                           this.categories.FESTE_PARTIES + ',' +
                           this.categories.FREIZEIT + ',' +
                           this.categories.UMWELT_NATUR
      axios.get(`https://www.kriens.ch/route/core-api-read/key/${this.apiKey}/component/event/model/event/archive/false/?daterange=6_monthes&category=${categoryString}`)
      .then((response) => {
        this.events = response.data.data.sort((a,b) => new Date(a.datestart) - new Date(b.datestart))
      })
      .catch((data) => {
        console.log('error getting events: ', data)
      })
    },
    showModal (event) {
      this.selectedEvent = event
      this.$modal.show('event-detail-modal');
    },
    getMonthString (language, dateString) {
      let date = new Date(dateString)
      return DateUtils.getMonth(language, date.getUTCMonth() + 1)
    },
    getDay (dateString) {
      let date = new Date(dateString)
      return date.getDate()
    }
  }
}
</script>